import { Injectable, inject } from '@angular/core';
import { CaseFormState } from '../../states/case-form.state';
import { GetCaseFormsStateResult } from './get-case-forms-state.result';

@Injectable({ providedIn: 'root' })
export class GetCaseFormsStateUseCase {
  private readonly _caseFormState = inject(CaseFormState);

  public execute(): GetCaseFormsStateResult {
    return {
      caseForms: this._caseFormState.caseForms,
      caseFormSelectedToEdit: this._caseFormState.caseFormSelectedToEdit,
      fieldTypes: this._caseFormState.fieldTypes,
      fieldConstraintTypes: this._caseFormState.fieldConstraintTypes,
      loadingCaseForms: this._caseFormState.loadingCaseForms,
      loadingCaseForm: this._caseFormState.loadingCaseForm,
      errorCaseForms: this._caseFormState.errorCaseForms,
      errorCaseForm: this._caseFormState.errorCaseForm,
      savingCaseForm: this._caseFormState.savingCaseForm,
      caseFormsCount: this._caseFormState.caseFormsCount,
      hasCaseForms: this._caseFormState.hasCaseForms,
    };
  }
}
